import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

// Initialize monitoring and security (before app render)
import { initWebVitals } from './utils/webVitals'
import { initSecurity } from './config/security'

// Import fonts (Geist used for both body and headings)
import '@fontsource/geist/400.css'
import '@fontsource/geist/400.css'
import '@fontsource/geist/500.css'
import '@fontsource/geist/600.css'
import '@fontsource/geist/700.css'

// Import Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css'

// Import Bootstrap JS (required for dropdowns, modals, etc.)
import 'bootstrap'

// Import custom styles (SCSS)
import './styles/main.scss'

import App from './App.tsx'

// Initialize Web Vitals monitoring (production only)
if (import.meta.env.MODE === 'production') {
  initWebVitals();
}

// Initialize security features
initSecurity();

// Set up axios interceptors for global error handling (401 session expiration)
import { setupAxiosInterceptors } from './config/axios';
setupAxiosInterceptors();

// Report app startup time
if ('performance' in window) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const entry = performance.getEntriesByType('navigation')[0];
      if (entry) {
        console.log(`[App] Startup time: ${Math.round(entry.loadEventEnd - entry.startTime)}ms`);
      }
    }, 0);
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </StrictMode>,
)
